import React from "react";

// Sentinel stored when a participant explicitly declines an item (opt-out).
// Distinct from a numeric rating, and non-null so a required item still passes
// validation — i.e. the participant must either rate the item or decline it.
export const LIKERT_OPT_OUT = "prefer_not_to_answer";

const LikertBatteryQuestion = ({ question, responses, onChange }) => {
  const {
    questionId,
    items = [],
    scale = {},
    allowOptOut = false,
    optOutLabel = "I prefer not to answer",
  } = question;
  const points = scale.points || 5;
  const labels = scale.labels || [];

  return (
    <div className="space-y-4">
      {/* Scale legend - shown once above all items */}
      {labels.length >= 2 && (
        <div className="flex items-center justify-center gap-3 flex-wrap px-2 mb-2">
          {labels.map((label, i) => (
            <div key={i} className="flex items-center gap-1.5 text-xs text-spiders-text-muted">
              <span className="w-5 h-5 rounded-full bg-spiders-bg-elevated flex items-center justify-center text-[10px] font-medium">
                {i + 1}
              </span>
              <span>{label}</span>
            </div>
          ))}
        </div>
      )}

      {items.map((item) => {
        const key = `${questionId}_${item.itemId}`;
        const value = responses[key];

        return (
          <div key={item.itemId} className="spiders-card p-4">
            <p className="text-spiders-text-primary text-sm mb-3 leading-relaxed">
              {item.text}
            </p>
            <div className="flex items-center gap-1">
              {/* Left anchor label */}
              <span className="text-xs text-spiders-text-secondary w-20 text-right pr-2 hidden sm:block leading-tight">
                {labels[0] || ""}
              </span>
              <div className="flex gap-1.5 justify-center flex-1">
                {Array.from({ length: points }, (_, i) => (
                  <button
                    key={i + 1}
                    onClick={() => onChange(key, i + 1)}
                    className={`w-9 h-9 rounded-full text-center transition-all text-xs font-medium flex items-center justify-center ${
                      value === i + 1
                        ? "bg-spiders-primary-500 text-white ring-2 ring-spiders-primary-500/50 scale-110"
                        : "bg-spiders-bg-elevated text-spiders-text-muted hover:bg-spiders-bg-light hover:text-spiders-text-secondary"
                    }`}
                    title={labels[i] || `${i + 1}`}
                  >
                    {i + 1}
                  </button>
                ))}
              </div>
              {/* Right anchor label */}
              <span className="text-xs text-spiders-text-secondary w-20 pl-2 hidden sm:block leading-tight">
                {labels[labels.length - 1] || ""}
              </span>
            </div>
            {allowOptOut && (
              <div className="mt-2 flex justify-center sm:justify-end">
                <button
                  onClick={() =>
                    onChange(key, value === LIKERT_OPT_OUT ? undefined : LIKERT_OPT_OUT)
                  }
                  className={`text-xs px-3 py-1.5 rounded-full transition-all ${
                    value === LIKERT_OPT_OUT
                      ? "bg-spiders-primary-500/20 text-spiders-primary-300 ring-1 ring-spiders-primary-500/50"
                      : "text-spiders-text-muted hover:text-spiders-text-secondary"
                  }`}
                >
                  {optOutLabel}
                </button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default LikertBatteryQuestion;
